
function Projects() {
  return (
    <div className="flex-col-container center">
      <div className="flex-row">
        Hi, I'm still under construction. Please check back later!
      </div>
    </div>
  );
}

export default Projects;